// extracted by mini-css-extract-plugin
export default {"table":"default_table__NzwO3","table__row":"default_table__row__-JrU6"};